import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';

import CustomPackageBuilder from './CustomPackageBuilder';

export default function CustomPackageBuilderWrapper() {
  const [resetKey, setResetKey] = useState(() => uuidv4());
  const location = useLocation();

  const resetBuilder = () => setResetKey(uuidv4());

  return (
    <CustomPackageBuilder
      key={resetKey}
      resetBuilder={resetBuilder}
      location={location}
    />
  );
}
